export default function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <header className="border-b border-[#e6e5df] px-6 md:px-10 py-6 flex flex-col md:flex-row md:items-end md:justify-between gap-4 bg-[#f7f5f1]" data-testid={testid}>
      <div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#647265] font-mono mb-2">MISCO • Rework Hub</div>
        <h1 className="font-display font-extrabold text-3xl md:text-4xl leading-none tracking-tight text-[#232826]">{title}</h1>
        {subtitle && <p className="text-sm text-[#6b6a68] mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-3">{actions}</div>}
    </header>
  );
}
